import React, {useState}      from 'react';
import classnames             from 'classnames';
import { FontAwesomeIcon }    from '@fortawesome/react-fontawesome';
import { Modal }              from 'react-bootstrap';

import Loading                from './Loading';
import ErrorLabel             from 'pu-react/components/base/ErrorLabel';
import SubstituteParts        from './SubstitutePartTable';

import PartImage              from './PartImage';
import PartDatasheet          from './PartDatasheet';
import PartInfo               from './PartInfo';

import IconDatasheet          from 'images/bom/Data-Sheet-Icon-On.svg'
import IconDatasheetDisable   from 'images/bom/Data-Sheet-Icon-Off.svg'

import {
  getDatasheetUrl,
  getPartStatus,
}from 'pu-utils/PartsUtilities';   

const Actions = (props) => {
  return(
    <div>
      <button type="button" 
       className="btn btn-outline-gray btn-thin" 
       onClick={props.onClose} >
        CANCEL
      </button>
      &nbsp;
      <button type="button" 
       className="btn btn-orange"
       onClick={props.onSaveSubstitutePart}>
        SAVE
        &nbsp;
        <i className="fas fa-caret-right"></i>
      </button>
    </div>
  )
}

const PartEmptyVendorBlock = (props) => {
  return(
    <React.Fragment>
      <td className="vendor"></td>
      <td className="stock"></td>
      <td className="required-qty"></td>
      <td className="price"></td>
      <td className="action"></td>
    </React.Fragment>
  )
}

const PartVendorBlock = (props) => {
  return(
    <React.Fragment>
      <td className="vendor">
        <div className="vendor">{props.option.vendor}</div>
        <div className="vpn">{props.option.vpn}</div>
      </td>
      <td className="stock">
        {props.option.stock}
      </td>
      <td className="required-qty">
        {props.option.qty}
      </td>
      <td className="price text-end">
        ${numeral(props.option.unit_price).format('0.00')}
      </td>
      <td className="action text-center">
        <input type="checkbox"
         value="1"
         onChange={e => props.onSelectSubstitutePart(e.target.checked,
                                                     props.offer_id, 
                                                     props.part_id, 
                                                     props.part, 
                                                     props.selected_quantity,
                                                     props.type)} />
      </td>
    </React.Fragment>
  )
}

const OtherPartRow = (props) => {
  var part = props.part;
  var vendor_options = part.vendor_options;
  var v_options = undefined;
  var options = []
  var rowspan = 1;

  if (vendor_options !== undefined 
      && Object.keys(vendor_options).length !== 0 
      && (props.selected_quantity in vendor_options)){
    v_options = vendor_options[props.selected_quantity];
    rowspan = v_options.length || 1;
  }

  if (v_options.length == 0) {
    options.push(
      <PartEmptyVendorBlock />
    )
  }

  v_options.forEach(function (option, index) {
    options.push(
      <PartVendorBlock 
       offer_id={props.offer_id} 
       part={part}
       part_id={part.id}
       option={option} 
       onSelectSubstitutePart={props.onSelectSubstitutePart} 
       type="others"/>
    )
  });

  var first_option = options[0];
  var options_length = options.length;
  if (options.length > 1) {
    options.shift()
  }

  return(
    <React.Fragment>
      <tr key={part.id}>
        <td className="image"
          rowSpan={rowspan}>
          <PartImage 
           images={part.image} 
           selected_quantity={props.selected_quantity} />
        </td>
        <td className="datasheet"
         rowSpan={rowspan}>
          <PartDatasheet 
           urls={part.datasheet} 
           selected_quantity={props.selected_quantity} />
        </td>
        <td className="mpn"
         rowSpan={rowspan}>
          <PartInfo 
           mpn={part.mpn}
           manufacturer={part.manufacturer}
           reference_designator={part.reference_designator} />
          <div className="descirption">
            {part.description}
          </div>
        </td>
        {first_option}
      </tr>
      {(options_length > 1)
        ? options.map((option) => (
            <tr>
              {option}
            </tr>
          ))
        : null
      } 
    </React.Fragment>
  )
}

const SimilarParts = (props) => {
  if (props.others === undefined || props.others.length  == 0){
    return null
  } 

  return(
    <div className="similar-parts">
      <div className="caption">
        We found similar parts that did not do a perfect match to the specified one.
      </div>
      <div className="search-table">
        <table className="table table-responsive">
          <thead>
            <tr>
              <th className="image"></th>
              <th className="datasheet"></th>
              <th className="mpn">Manufacturer Part Number</th>
              <th className="vendor">Vendor</th>
              <th className="stock">Stock</th>
              <th className="order-qty">Qty</th>
              <th className="price">Price</th>
              <th className="action"></th>
            </tr>
          </thead>
          <tbody>
            {props.others.map((part) => (
              <OtherPartRow
                offer_id={props.offer_id} 
                part = {part}
                selected_quantity={props.selected_quantity}
                onSelectSubstitutePart={props.onSelectSubstitutePart} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const SubstitutePart = (props) => {
  const [part, setPart] = useState("")

  if (!props.offer_id) return null 
  let show = true;
  let offer = props.quote.offers[props.offer_id];
  let status = getPartStatus(offer.status, props.selected_quantity)
  
  const submit = (e) =>{
    e.preventDefault();
    props.onSearchPart(part);
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (part.length >= 3){
        props.onSearchPart(part);
      }
    }
  }

  const handleClose = () => {
    setPart("");
    props.onCloseSubstitutePart();
  }

  const handleSaveSubstitutePart = () => {
    setPart("");
    props.onSaveSubstitutePart();
  }
  

  let url =  getDatasheetUrl(offer.datasheet, props.selected_quantity);

  var description = "";
  if (offer.description != undefined && offer.description != ""){
    description = offer.description
  }else{
    if(offer.original_description != null && offer.original_description != ""){
      description = offer.original_description;
    }
  }
  
  return(
    <Modal className="bom-tool-modal substitute-part-modal" 
     show={show} size="xl"
     onHide={handleClose} 
     animation={false} centered={true} 
     backdrop="static" >
      <Loading loading={props.loading} />
      <Modal.Header closeButton>
        <Modal.Title>
          BOM QUOTE
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="part-detail">
          <div className="part-header container">
            <div className="row">
              <div className="col-5">
                <strong>Original Manufacturer Part Number:</strong>&nbsp;
                {offer.mpn}
              </div>
              <div className="col-4">
                <strong>Manufacturer:</strong>&nbsp;
                {offer.manufacturer || "-"}
              </div>
              <div className="col-3">
                <div className={"datasheet" + (url == "" ? " disable" : "")}>
                  DataSheet
                  <a className="part-datasheet" 
                   href={url == "" ? "javascript:void(0)" : url} 
                   target={url == "" ? "" : "_blank"} >
                    <img className="datasheet-image" 
                     src={url == "" ? IconDatasheetDisable : IconDatasheet} 
                     alt="Part Datasheet" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          {(description != "")
            ? <div className="part-content container">
                <div className="row">
                  <div className="col-12">
                    <div className="description">
                      {description}
                    </div>
                  </div>
                </div>
              </div>
            : null }
        </div>

        <div className="part-search-content">
          {(status == "no-perfect-match")
            ? 
              <SimilarParts 
               offer_id={props.offer_id} 
               mpn={offer.mpn}
               others = {offer.others}
               selected_quantity={props.selected_quantity}
               onSelectSubstitutePart={props.onSelectSubstitutePart} />
            : null
          }

          <div className="substitute">
            <div className="caption">
              Find a substitute
            </div>
            <div className="d-flex">
              <div className="col-5">
                <form className="substitute-part-form"
                 onSubmit={submit} >
                  <div className="input-group input-group-sm">
                    <input type="text" className="form-control" 
                     placeholder="Type a manufacturer or vendor part number" 
                     aria-label="Type a manufacturer or vendor part number " 
                     aria-describedby="button-search" 
                     name="part"
                     value={part}
                     onChange={e => setPart(e.target.value)}
                     onKeyDown={handleKeyDown} />
                    <div className="input-group-append">
                      <button className="btn btn-primary" 
                       type="submit" id="button-search">
                        <FontAwesomeIcon icon={['fas', 'search']} /> 
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-6">
                {(props.substitute_parts.length > 0 ) 
                  ? <div className="qty-needed">
                      QUANTITY NEEDED
                      <span>
                        {offer.qty_per_board * props.selected_quantity}
                      </span>
                    </div>
                  : null
                }
              </div>
            </div>
            <SubstituteParts
             offer_id={props.offer_id} 
             offer={offer}
             substitutes={props.substitute_parts} 
             needed_quantity={offer.qty_per_board * props.selected_quantity}
             qty_per_board={offer.qty_per_board}
             onSelectSubstitutePart={props.onSelectSubstitutePart} />
          </div>
        </div>

        <div className="modal-footer">
          <Actions 
           onClose={handleClose}
           onSaveSubstitutePart={handleSaveSubstitutePart} />
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SubstitutePart;
